import { useRef, useState } from "react";
import { useFilter } from "../../../Hooks/useFilter";
import {
  ButtonGroup,
  CircularProgress,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { ArrowDropDownOutlined } from "@mui/icons-material";
import { ReportButton } from "./styles";
import Tooltip from "../../Atoms/Tooltip";
import api from "../../../Services/api";

const formats = {
  'excel': "Baixar relatório (Excel)",
  'csv': 'Baixar relatório (CSV)',
  'ofx': 'Baixar relatório (OFX)'
}

export const ReportDownload = ({ startDate, endDate, type, hasData }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);
  const [selectedFormat, setSelectedFormat] = useState('csv');
  const [isLoading, setIsLoading] = useState(false);

  const { getFilterObj } = useFilter();
  const extractFilterObj: any = getFilterObj("extract");

  const handleDownloadReport = async () => {
    let url = '/accounts/statements/csv';
    let ext = 'csv';
    if(selectedFormat === 'excel') {
      url = '/accounts/statements/excel';
      ext = 'xlsx';
    }
    if(selectedFormat === 'ofx') {
      url = '/accounts/statements/ofx';
      ext = 'ofx';
    }

    try {
      setIsLoading(true);
      const response = await api.get(url, {
        params: { ...extractFilterObj },
        responseType: 'blob'
      });

      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
      const $link = document.createElement('a');
      $link.href = blobUrl;
      $link.download = `extrato ${extractFilterObj.start_date} ate ${extractFilterObj.end_date}.${ext}`

      $link.click();
    }
    finally {
      setIsLoading(false);
    }
  };

  const handleMenuItemClick = (key = '') => {
    setSelectedFormat(key);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  return (
    type === "extract" && (
      <>
      
        <ButtonGroup
          variant="contained"
          ref={anchorRef}
          aria-label="split button"
          sx={{ alignItems: 'center' }}
        >
          <Tooltip title="Download do relatório no formato selecionado">
            <ReportButton
              onClick={handleDownloadReport}
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress size={18} sx={{ color: '#FFF' }} />
              ) : (
                formats[selectedFormat]
              )}
            </ReportButton>
          </Tooltip>
          <Tooltip title="Selecionar formato">
            <ReportButton
              aria-controls={open ? "split-button-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-label="select merge strategy"
              aria-haspopup="menu"
              onClick={handleToggle}
            >
              <ArrowDropDownOutlined />
            </ReportButton>
          </Tooltip>
        </ButtonGroup>
        <Popper
          sx={{
            zIndex: 1,
          }}
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu" autoFocusItem>
                    {
                      Object.keys(formats).map(key => (
                        <MenuItem
                          key={key}
                          selected={key === selectedFormat}
                          onClick={() => handleMenuItemClick(key)}
                        >
                          {formats[key]}
                        </MenuItem>
                      ))
                    }
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </>
    )
  );
};
